import Header from '../../../components/common/layout/Header';
import { useTranslation } from 'react-i18next';
import SecondaryBtnLight from '../../../components/common/form/SecondaryBtnLight';
import { useNavigate } from 'react-router-dom';
import { LogoIcon } from '../../../components/common/svg/AllSvg';
import Canonical from '../../../components/common/layout/Canonical';
import CorporateHeader from '../../../components/common/layout/CorporateHeader';

const CommingSoon = ({ type }: any) => {
    const { t } = useTranslation('common');
    const navigate = useNavigate();

    return (
        <div className="w-full h-full dark:bg-bgDarkDull bg-white">
            <Canonical />
            {type === "passenger" ? <Header type={type} /> : <CorporateHeader />}

            <div className="w-full h-full container mt-[80px] xlx:mt-[110px] pb-[40px] flex flex-col items-center justify-center" id="home">
                <LogoIcon />
                <h1 className='text-primaryText dark:text-white uppercase font-bold mt-[15px] text-center'>{t("coming_soon.title")}</h1>
                <h4 className='text-primary font-semibold text-center'>{t("coming_soon.subtitle")}</h4>
                <h5 className='text-center text-blackDull dark:text-textBlackDull font-medium mt-[20px] max-w-[600px]'>{t("coming_soon.desc")}</h5>
                <div className='flex items-center justify-center w-full mt-[35px] mb-[70px]'>
                    <SecondaryBtnLight title={t("coming_soon.go_back")} css="px-[40px] xlx:px-[64px] uppercase font-bold rounded-[6px] text-base leading-snug w-fit text-primary border border-primary focus:!shadow-[0_0_0_3px_#059db25e] hover:!shadow-[0_0_0_3px_#059db25e]" onClick={() => navigate(-1)} />
                </div>

                <img src={require("../../../assets/images/coming-soon.png")} alt="coming-soon" />
            </div>
        </div>
    );
};

export default CommingSoon;